export function Scanlines() {
  return <div className="scanlines" aria-hidden="true" />;
}
